// UID: BWR-FIN_STMT_1Y_Q3-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2347
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2247
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  HasApplicantNotFiledTR,
  HasApplicantFiledTR,
  IsBetweenJanAndMidFeb,
  IsBusinessEstablishedMoreThan,
  IsExpressLoan,
  IsForProfit,
  RulesetResult,
} from '../rules';
import IsBusinessEstablishedEqualTo from '../rules/IsBusinessEstablishedEqualTo';
import IsBusinessEstablishedLessThan from '../rules/IsBusinessEstablishedLessThan';

class FinancialStatementLastYearQ3Ruleset implements Ruleset {
  public forProfitResult = (
    data: Partial<ApplicationFormValues>
  ): RulesetResult => {
    const isExpress = IsExpressLoan.evaluate(data);

    const establishedMoreThanZeroYearsAgo =
      IsBusinessEstablishedMoreThan.setYears(0).evaluate(data);

    const isBetweenJanAndMidFeb = IsBetweenJanAndMidFeb.evaluate(data);
    if (isBetweenJanAndMidFeb) {
      if (establishedMoreThanZeroYearsAgo && !isExpress)
        return RulesetResult.REQUIRED;
      return RulesetResult.OPTIONAL;
    }
    return RulesetResult.HIDDEN;
  };

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isForProfit = IsForProfit.evaluate(data);
    if (isForProfit) return this.forProfitResult(data);
    const businessEstablishedTwoYearsAgo =
      IsBusinessEstablishedEqualTo.setYears(2).evaluate(data);
    const businessEstablishedLessThanTwoYearsAgo =
      IsBusinessEstablishedLessThan.setYears(2).evaluate(data);
    const hasApplicantEverFiledTR = HasApplicantFiledTR.evaluate(data);
    const hasApplicantNotEverFiledTR = HasApplicantNotFiledTR.evaluate(data);
    const isBetweenJanAndMidFeb = IsBetweenJanAndMidFeb.evaluate(data);

    if (
      hasApplicantNotEverFiledTR &&
      (businessEstablishedTwoYearsAgo || businessEstablishedLessThanTwoYearsAgo)
    ) {
      if (isBetweenJanAndMidFeb)
        return businessEstablishedTwoYearsAgo
          ? RulesetResult.REQUIRED
          : RulesetResult.OPTIONAL;
      return RulesetResult.HIDDEN;
    }

    if (hasApplicantNotEverFiledTR && isBetweenJanAndMidFeb)
      return RulesetResult.REQUIRED;

    if (isBetweenJanAndMidFeb && hasApplicantEverFiledTR)
      return IsExpressLoan.evaluate(data)
        ? RulesetResult.OPTIONAL
        : RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}

export default new FinancialStatementLastYearQ3Ruleset();
